import { createTheme } from "@mui/material/styles";
import { secondaryColor as secondaryColorValue } from "../scss/colors.module.scss";
import { DEFAULT_PRIMARY, DEFAULT_SECONDARY } from "./theme-utils";

export const getColorByPropertyValue = (value) => {
  if (typeof document !== "undefined") {
    const computedValue = getComputedStyle(
      document.documentElement
    ).getPropertyValue(value);
    return computedValue.trim() || null;
  }
  return null;
};

export const resolveColor = (color) => {
  if (color.startsWith("var(")) {
    const variableName = color.match(/var\(([^)]+)\)/)?.[1];
    if (variableName) {
      return getColorByPropertyValue(variableName) || color;
    }
  }
  return color;
};

/** Theme colors resolved from CSS variables (tenant theme). */
export const getThemeColor = () => {
  return {
    primaryColor: getColorByPropertyValue("--primaryColor") || DEFAULT_PRIMARY,
    secondaryColor:
      getColorByPropertyValue("--secondaryColor") || DEFAULT_SECONDARY,
    textColor: getColorByPropertyValue("--textColor") || "#040d13",
    textOnPrimary: getColorByPropertyValue("--textOnPrimary") || "#000000",
    textOnSecondary: getColorByPropertyValue("--textOnSecondary") || "#ffffff",
  };
};

export const theme = createTheme({
  typography: {
    fontFamily: "ProximaNovaRegular",
  },
  palette: {
    primary: {
      main: DEFAULT_SECONDARY,
    },
    secondary: {
      main: DEFAULT_PRIMARY,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1025,
      lg: 1280,
      xl: 1920,
    },
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: ({ theme: muiTheme }) => ({
          backgroundColor: "white",
          color: "rgba(0, 0, 0, 0.87)",
          fontSize: "16px",
          boxShadow: muiTheme.shadows[1],
          border: `1px solid ${secondaryColorValue}`,
          "& .MuiTooltip-arrow": {
            color: "white",
            "&::before": {
              border: `1px solid ${secondaryColorValue}`,
            },
          },
        }),
      },
    },
  },
});
